export type Projecttype = 'full' | 'premium' | 'lite';
export type Role = 'Manager' | 'Vendor' | 'User';

export class User {
    account = '';
    referrername = '';
    referrerlastname = '';
    email = '';
    password = '';
    registrationlink = '';
    accepttermpolicy: boolean;
    acceptdatapolicy: boolean;
    role = '';
    admincreated: boolean;
}
export interface InfoUser {
  token: string;
  role: Role;
  vendor: string;
  projecttype: Projecttype;
  email: string;
}
